interface HtmlDirective {
  className: string
  autoComplete?: string
  accept?: string
  multiple?: any
  label?: string
  name?: string
  type?: string
  min?: string | number
  max?: string | number
  value?: string | number
  error?: string
  checked?: boolean
  ref?: any
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export const InputField = (htmlDirective: HtmlDirective) => {
  const { label, error, name } = htmlDirective

  return (
    <>
      <label htmlFor={`${name}`}>{label}</label>
      <input id={`${name}`} {...htmlDirective}></input>
      {error && <span className="text-red-500">{error}</span>}
    </>
  )
}
